export default __webpack_public_path__ + "static/media/6.eca63a25.JPG";